import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const FourOhFour: React.FC = function FourOhFour() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const handleReturn = () => {
    navigate('/walks')
  }
  return (
    <div className="container mt-5">
      <div className="text-center text-white">
        <h1 className=''>{t('whoops')}</h1>
        <p className='pt-3'>{t('nothing_there')}</p>
        <p className='pt-3'>{t('what_looking_for')}</p>
        <button type="button" className="btn btn-primary mt-3" onClick={handleReturn}>{t('return_domain_living')}</button>
      </div>
    </div>
  )
}

export default FourOhFour
